import React, { Component } from "react";
import {
  Button,
  Container,
  Row,
  Form,
  Col,
  Card,
  Tooltip,
  OverlayTrigger,
  Table,
} from "react-bootstrap";

import { toast } from "react-toastify";
import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
export default class Requestjson extends Component {
  constructor(props) {
    super(props);

    const integId = sessionStorage.getItem("integrationlibrary_Id");
    const savedJsonData =
      sessionStorage.getItem("requestJsonData_" + integId) || "";

    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],

      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      requestId: sessionStorage.getItem("requestId"),
      jsondata1: sessionStorage.getItem("testapidata_" + integId),
      integId: integId,
      errors: {},
      filteredData: null,
      currentPage: 1,
      isSuccessretrieve: false,
      showRetrieveButton: false,
      itemsPerPage: 10,
      jsonData: savedJsonData,

      tables: [],
      columns: [],
      columnsone: [],
      rcolumns: [],
      columnsWT: [],
      sendingHeader: [],
      dynamicTables: [],
      headerData: {
        jsonkey: "",
        tableName: "",
        columnName: "",
        sampleValue: "",
        currentStep: 1,
      },
      defaultDistdefaultDist: {
        id: 0,
        rows: [],
      },

      //***state
    };
  }

  addTable = () => {
    const newId = this.state.dynamicTables.length + 1;
    this.setState((prevState) => ({
      dynamicTables: [
        ...prevState.dynamicTables,
        {
          id: newId,
          tableName: "",
          rows: [],
        },
      ],
      headerData: {
        jsonkey: "",
        tableName: "",
        columnName: "",
        sampleValue: "",
      },
    }));
  };

  deleteTable = (id) => {
    this.setState((prevState) => ({
      dynamicTables: prevState.dynamicTables.filter((table) => table.id !== id),
    }));
  };
  handleEditInputChangeHeader(index, field, value) {
    const updatedHeader = [...this.state.sendingHeader];
    updatedHeader[index][field] = value;
    this.getColumns(value, "rcolumns");
    this.setState({ sendingHeader: updatedHeader });
  }
  handleRemoveSpecificRowHeader = (tableId, rowId) => {
    console.log("Deleting row with ID:", rowId, "from Table ID:", tableId);
    this.setState((prevState) => ({
      dynamicTables: prevState.dynamicTables.map((table) =>
        table.id === tableId
          ? { ...table, rows: table.rows.filter((row) => row.id !== rowId) }
          : table
      ),
    }));
  };
  handleEditTableRowHeader(index) {
    this.setState({ editingIndex: index });
  }

  mergeTables = (dataArray) => {
    const merged = {};

    dataArray.forEach((tableObj) => {
      if (tableObj.table_name) {
        if (!merged[tableObj.table_name]) {
          merged[tableObj.table_name] = {
            table_name: tableObj.table_name,
            columns: [],
          };
        }
        // Merge all columns into the correct table
        merged[tableObj.table_name].columns.push(...tableObj.columns);
      }
    });

    return merged;
  };
  addSendhrRow = (tableId, e) => {
    e.preventDefault();

    this.setState((prevState) => {
      const selectedJsonKey = prevState.headerData.jsonkey;
      const selectedSampleValue = prevState.headerData.sampleValue;
      const selectedColumnName = prevState.headerData.columnName;
      const selectedTableName = prevState.dynamicTables.find(
        (t) => t.id === tableId
      )?.tableName;

      if (
        !selectedJsonKey ||
        !selectedSampleValue ||
        !selectedColumnName ||
        !selectedTableName
      ) {
        alert("Please select all required fields.");
        return prevState;
      }

      // Get the current number of rows in this table and increment index
      const currentTable = prevState.dynamicTables.find(
        (t) => t.id === tableId
      );
      const rowIndex = currentTable?.rows.length + 1 || 1; // Incrementing index

      // New row to add in UI with an increasing index
      const newRow = {
        id: rowIndex, // Incrementing ID instead of timestamp
        jsonKey: selectedJsonKey,
        tableName: selectedTableName,
        columnName: selectedColumnName,
        value: selectedSampleValue,
      };

      // Find if table already exists in sendingHeader
      let tableIndex = prevState.sendingHeader.findIndex(
        (t) => t.table_name === selectedTableName
      );
      let updatedSendingHeader = [...prevState.sendingHeader];

      if (tableIndex !== -1) {
        // Check if the same column already exists to avoid duplicates
        let existingRowIndex = updatedSendingHeader[
          tableIndex
        ].columns.findIndex(
          (col) =>
            col.key === selectedJsonKey &&
            col.column_name === selectedColumnName
        );

        if (existingRowIndex === -1) {
          // If the row doesn't exist, add it
          updatedSendingHeader[tableIndex].columns.push({
            key: selectedJsonKey,
            column_name: selectedColumnName,
            sample_value: selectedSampleValue,
          });
        } else {
          console.warn("Duplicate row detected! Skipping...");
        }
      } else {
        // If table does not exist, create a new entry
        updatedSendingHeader.push({
          table_name: selectedTableName,
          columns: [
            {
              key: selectedJsonKey,
              column_name: selectedColumnName,
              sample_value: selectedSampleValue,
            },
          ],
        });
      }

      // Update state
      return {
        dynamicTables: prevState.dynamicTables.map((table) =>
          table.id === tableId
            ? { ...table, rows: [...table.rows, newRow] }
            : table
        ),
        sendingHeader: updatedSendingHeader,
        headerData: {
          jsonkey: "",
          tableName: selectedTableName,
          columnName: "",
          sampleValue: "",
        },
      };
    });
  };

  handleclick = () => {
    sessionStorage.setItem("isNewEntry", "false");
    window.location.href = "./integration_library";
  };
  handleJsonChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    try {
      const parsedData = JSON.parse(fieldValue);
      this.setState({
        jsonData: JSON.stringify(parsedData, null, 2),
      });
    } catch (error) {
      console.error("Invalid JSON format:", error);
      this.setState({ jsonData: fieldValue });
    }
  };

  // handleFormRetrie = (e) => {
  //   e.preventDefault();
  //   var formData = new FormData();
  //   formData.append("sId", this.state.sId);
  //   formData.append("uId", this.state.uId);
  //   formData.append("requestId", this.state.requestId);
  //   fetch(configData.api_url + "C_Integrationlibrary/retriveJson", {
  //     method: "POST",
  //     mode: "cors",
  //     body: formData,
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       this.showToast(data.message, data.status);
  //       if (data.status === "success") {
  //         this.setState({
  //           jsonData: JSON.stringify(data.data),
  //           isSuccessretrieve: true,
  //           SampleJSONrequest: [],
  //         });
  //       }
  //     })
  //     .catch((error) => console.error("Error:", error));
  // };

  handleChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ jsonData: fieldValue });
  };

  onSubmitTest = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integrationlibrary_Id", this.state.integId);
    formData.append("jsonData", JSON.stringify(this.state.jsonData));
    fetch(configData.api_url + "C_Integrationlibrary/testapi", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          // Store per-integration so one API's test result can't be saved under another.
          sessionStorage.setItem(
            "testapidata_" + this.state.integId,
            JSON.stringify(data.result)
          );
          this.setState({ isSuccess: true });
        }
      });
  };

  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;

      case "error":
        toast.error(msg);

        break;

      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'

        break;

      default:
        toast.info(msg);
    }
  };

  RequestjsoneditHandler = (e) => {
    e.preventDefault();

    // const updateFormData = {...editFormData};

    // updateFormData['Requestjson_Id'] = e.target.parentElement.getAttribute("id");

    // setEditFormData(updateFormData);

    // setEdit(true);
  };

  // C_Integrationlibrary/saveResJson
  //C_Integrationlibrary/downloadRequestJson
  //params: integId, requestId
  RequestjsonsubmitHandler = (e) => {
    e.preventDefault();

    // Guard: the response saved comes from the latest "Call API" of THIS integration.
    // If there is no fresh test result for this integId, abort so we don't save stale data.
    const storedDataCheck = sessionStorage.getItem(
      "testapidata_" + this.state.integId
    );
    if (!storedDataCheck) {
      this.showToast(
        "Please click 'Call API' first to fetch the response for this integration.",
        "warning"
      );
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", this.state.integId);
    // formData.append("jsonData", JSON.stringify(this.state.jsonData));
    formData.append("jsonData", this.state.jsonData);
    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          sessionStorage.setItem("requestId", data.requestId);
          //  sessionStorage.setItem("storedData", data.result);
          // Retrieve stored session data (per-integration test result)
          let storedData = sessionStorage.getItem(
            "testapidata_" + this.state.integId
          );

          let resFormData = new FormData();
          resFormData.append("sId", this.state.sId);
          resFormData.append("uId", this.state.uId);
          resFormData.append("requestId", data.requestId);
          resFormData.append("integId", this.state.integId);
          resFormData.append("jsonData", storedData);

          // Submit to saveResJson API
          return fetch(
            configData.api_url + "C_Integrationlibrary/saveResJson",
            {
              method: "POST",
              mode: "cors",
              body: resFormData,
            }
          );
        }
      })
      .then((res) => res.json())
      .then((resData) => {
        if (resData?.status === "success") {
          sessionStorage.setItem("responseId", resData?.responseId);
          this.setState({ isSaveButton: true });
        }
      })

      .catch((error) => console.error("Error:", error));
  };

  Handledowloadcsv = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", this.state.integId);
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Integrationlibrary/downloadRequestJson", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);
        const csvContent = `${configData.api_url}${data.filePath}`;
        const link = document.createElement("a");
        link.setAttribute("href", csvContent);
        link.setAttribute("download", `requestjson.xlsx`); // Custom file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => {
          window.location.href = "/responsejson";
        }, 5000);
      });
  };
  RequestjsonupdateHandler = (e) => {
    e.preventDefault();

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("integId", this.state.integId);

    formData.append("requestId", this.state.requestId);

    //***tableData1
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Requestjson/update", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  handleintegIdChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ integId: fieldValue });
  };
  handlerequestIdChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ requestId: fieldValue });
  };

  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];

    const index = oldData.index;

    data[index] = newData;

    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    var formData = new FormData();

    formData.append("requestjson_Id", row.requestjson_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Requestjson/delete", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });

    this.setState({ filteredData });
  };

  componentDidMount() {
    this.getTables();
    this.retrieveSavedJson();

    //***componentDidMount
  }

  // Load the previously saved request JSON for this integration from the DB,
  // so the user does not have to re-feed it every time.
  retrieveSavedJson = () => {
    if (!this.state.integId) return;
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", this.state.integId);
    fetch(configData.api_url + "C_Integrationlibrary/retriveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.data) {
          const loaded =
            typeof data.data === "string"
              ? data.data
              : JSON.stringify(data.data, null, 2);
          this.setState({ jsonData: loaded });
          sessionStorage.setItem(
            "requestJsonData_" + this.state.integId,
            loaded
          );
        }
      })
      .catch((error) => console.error("retrieveSavedJson error:", error));
  };
  getTables = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "masters/gettables", {
      method: "POST",
      mode: "cors",
      body: {},
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({ tables: data.tables });
        }
      });
  };
  getColumns = (tableName, rcolumn) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("tableName", tableName);
    fetch(configData.api_url + "masters/getcolumns", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({ [rcolumn]: data.columns });
        }
      });
  };

  inputtableSHrChange = (e, tableId) => {
    e.preventDefault();
    const fieldValue = e.target.value;

    this.setState(
      (prevState) => ({
        dynamicTables: prevState.dynamicTables.map((table) =>
          table.id === tableId ? { ...table, tableName: fieldValue } : table
        ),
      }),
      () => {
        this.getColumns(fieldValue, "columns"); // Fetch columns for the selected table
      }
    );
  };

  fixLooseJson = (input) => {
    // Add quotes around unquoted keys
    return input.replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":');
  };
  inputSHrChange = (e) => {
    const { name, value } = e.target;
    let sampleValue = this.state.headerData.sampleValue;

    if (name === "jsonkey") {
      try {
        const fixedJson = this.fixLooseJson(this.state.jsonData || "{}");
        const parsed = JSON.parse(fixedJson);
        const rawValue = parsed[value];
        if (typeof rawValue === "object" && rawValue !== null) {
          sampleValue = JSON.stringify(rawValue);
        } else {
          sampleValue = rawValue !== undefined ? String(rawValue) : "";
        }
      } catch (err) {
        sampleValue = "";
      }
    } else if (name === "sampleValue") {
      sampleValue = value;
    }

    this.setState((prevState) => ({
      headerData: {
        ...prevState.headerData,
        [name]: value,
        sampleValue,
      },
    }));
  };

  keyvalidatehr() {
    const { currentStep, headerData } = this.state;
    let formIsValid = true;
    if (!headerData["jsonkey"]) {
      formIsValid = false;
      toast.info("*Enter Header Key.");
    } else if (!headerData["tableName"]) {
      formIsValid = false;
      toast.info("*Select Header Table Name.");
    } else if (!headerData["columnName"]) {
      formIsValid = false;
      toast.info("*Select Header Column Name.");
    } else if (!headerData["sampleValue"]) {
      formIsValid = false;
      toast.info("*Enter Header Sample value.");
    } else {
      // If all fields are filled, proceed to the next step
      this.setState({ currentStep: currentStep + 1 });
    }
    return formIsValid;
  }
  ResponsejsonsubmitHandler = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", this.state.integId);
    formData.append("requestId", this.state.requestId);
    // Merge the `sendingHeader` array before submitting
    const mergedTables = this.mergeTables(this.state.sendingHeader);
    var payload = {};
    console.log("mergedTables:", mergedTables);
    // fetch(configData.api_url + "C_Responsejsonmapping/ad
    payload["tables"] = mergedTables;
    console.log("Payload to be sent:", JSON.stringify(payload, null, 2));
    formData.append("jsonData", JSON.stringify(payload, null, 2));
    console.log("formData:", JSON.stringify(payload));
    fetch(configData.api_url + "C_Responsejsonmapping/requestadd", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          //window.location.href = "./responsejson";
        }
      })
      .catch((error) => {
        console.error("Error submitting JSON data:", error);
      });
  };

  renderTooltip = (text) => <Tooltip id="button-tooltip">{text}</Tooltip>;
  render() {
    const { isSuccess, jsonData, isSaveButton } = this.state;

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <Row>
          <Col xs={4} sm={4} lg={4}>
            <OverlayTrigger
              placement="top"
              overlay={this.renderTooltip("Integration Library")}
              onClick={this.handleclick}
            >
              <Card className="nav-card">
                <span className="bi bi-boxes nav-icon"></span>
                <p className="nav-label" onClick={this.handleclick}>
                  Integration Library
                </p>
              </Card>
            </OverlayTrigger>
          </Col>

          <Col xs={4} sm={4} lg={4}>
            <OverlayTrigger
              placement="top"
              overlay={this.renderTooltip("Request JSON")}
            >
              <Card
                className="nav-card active-step"
                onClick={() => this.setState({ step: 2 })}
              >
                <span className="bi bi-journal-album nav-icon"></span>
                <p className="nav-label">Request JSON</p>
              </Card>
            </OverlayTrigger>
          </Col>

          <Col xs={4} sm={4} lg={4}>
            <OverlayTrigger
              placement="top"
              overlay={this.renderTooltip("Response JSON Mapping")}
            >
              <Card
                className="nav-card "
                onClick={() => this.setState({ step: 3 })}
              >
                <span className="bi bi-table nav-icon"></span>
                <p className="nav-label">Response JSON Mapping</p>
              </Card>
            </OverlayTrigger>
          </Col>
        </Row>
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                 dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Request JSON
                      </h3>
                    </div>

                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Container style={{ overflowY: "auto", height: "auto" }}>
                        <Row className="divstyle">
                          <Row>
                            <Form>
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Integrationlibrary Id
                                  </Form.Label>
                                </Col>

                                <Col lg="8" md="8">
                                  <Form.Control
                                    type="number"
                                    disabled
                                    onChange={this.handleintegIdChange}
                                    className="form-control"
                                    name="integrationlibrary_Id"
                                    value={this.state.integId}
                                    required="required"
                                  />
                                </Col>
                              </Row>
                              <br />

                              <Row className="divstyle">
                                <Col>
                                  <Form.Group>
                                    <Form.Label>JSON Data</Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      rows="10"
                                      cols="50"
                                      value={jsonData}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        sessionStorage.setItem(
                                          "requestJsonData_" +
                                            this.state.integId,
                                          value
                                        );
                                        this.setState({ jsonData: value });
                                      }}
                                      placeholder="Enter JSON data here"
                                      style={{
                                        width: "100%",
                                        margin: "10px 0",
                                      }}
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <Button
                                    variant="warning"
                                    className="button"
                                    onClick={(e) => this.onSubmitTest(e)}
                                  >
                                    Call API
                                  </Button>
                                </Col>
                              </Row>

                              <br />

                              {isSuccess && (
                                <Row>
                                  <p>Request Id :{this.state.requestId}</p>
                                  <Col
                                    className="d-flex justify-content-end"
                                    style={{ marginRight: "50px" }}
                                  >
                                    <Button
                                      className="button"
                                      variant="success"
                                      onClick={this.RequestjsonsubmitHandler}
                                      style={{
                                        marginTop: "20px",
                                      }}
                                    >
                                      Save
                                    </Button>
                                  </Col>
                                </Row>
                              )}
                              {isSaveButton && (
                                <Row>
                                  <Col
                                    className="d-flex justify-content-end"
                                    style={{ marginRight: "50px" }}
                                  >
                                    {" "}
                                    <Button
                                      className="button bi bi-arrow-down"
                                      variant="success"
                                      onClick={this.Handledowloadcsv}
                                      style={{
                                        marginTop: "20px",
                                      }}
                                    />
                                  </Col>
                                </Row>
                              )}
                              {/* <Row>
                                {isSuccess && (
                                  <Col>
                                    {this.state.showRetrieveButton && (
                                      <Button
                                        variant="success"
                                        className="button"
                                        onClick={(e) =>
                                          this.handleFormRetrie(e)
                                        }
                                      >
                                        Retrieve
                                      </Button>
                                    )}
                                  </Col>
                                )}
                              </Row> */}
                            </Form>
                            <Col>
                              <p>
                                Spliting JSON In To Table By Adding Tables and
                                Columns
                              </p>
                              <Button
                                variant="primary"
                                className="bi bi-plus"
                                onClick={this.addTable}
                              >
                                Add Table
                              </Button>
                            </Col>
                            {this.state.dynamicTables.map((table, index) => (
                              <div key={table.id}>
                                <h3>Table {table.id}</h3>
                                <Col>
                                  <Button
                                    variant="warning"
                                    onClick={() => this.deleteTable(table.id)}
                                    className="bi bi-trash"
                                  >
                                    delete Table
                                  </Button>
                                </Col>
                                <Row>
                                  <Col>
                                    <Table
                                      className="table table-bordered table-hover"
                                      id="tab_logic"
                                    >
                                      <thead>
                                        <tr>
                                          <th className="text-center">S.NO</th>
                                          <th className="text-center">KEY</th>
                                          <th className="text-center">
                                            Table Name
                                          </th>
                                          <th className="text-center">
                                            Column Name
                                          </th>
                                          <th className="text-center">
                                            Sample
                                          </th>
                                          <th className="text-center">
                                            Actions
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {table.rows.map((row) => (
                                          <tr key={row.id}>
                                            <td>{row.id}</td>
                                            <td>{row.jsonKey}</td>

                                            <td>{table.tableName}</td>
                                            <td>{row.columnName}</td>
                                            <td>{row.value}</td>

                                            <td>
                                              <button
                                                variant="danger"
                                                className="bi bi-trash-fill btn btn-danger"
                                                onClick={() =>
                                                  this.handleRemoveSpecificRowHeader(
                                                    table.id,
                                                    row.id
                                                  )
                                                }
                                              ></button>
                                            </td>
                                          </tr>
                                        ))}
                                        <tr>
                                          <td>---</td>
                                          <td>
                                            <Form.Select
                                              name="jsonkey"
                                              value={
                                                this.state.headerData.jsonkey
                                              }
                                              onChange={this.inputSHrChange}
                                            >
                                              <option>Select Key</option>
                                              {Object.keys(
                                                JSON.parse(
                                                  this.fixLooseJson(
                                                    this.state.jsonData || "{}"
                                                  )
                                                )
                                              ).map((key, index) => (
                                                <option key={index} value={key}>
                                                  {key}
                                                </option>
                                              ))}
                                            </Form.Select>
                                          </td>
                                          <td>
                                            <Form.Control
                                              as="select"
                                              className="form-select"
                                              name="tableName"
                                              // value={
                                              //   this.state.headerData.tableName
                                              // }
                                              value={table.tableName || ""}
                                              onChange={(e) =>
                                                this.inputtableSHrChange(
                                                  e,
                                                  table.id
                                                )
                                              }
                                              disabled={table.tableName}
                                            >
                                              <option defaultValue>
                                                Select Table
                                              </option>
                                              {this.state.tables.map(
                                                (api, index, idx) => (
                                                  <option
                                                    key={index}
                                                    value={api}
                                                  >
                                                    {api}
                                                  </option>
                                                )
                                              )}
                                            </Form.Control>
                                          </td>
                                          <td>
                                            <Form.Control
                                              as="select"
                                              className="form-select "
                                              name="columnName"
                                              value={
                                                this.state.headerData.columnName
                                              }
                                              onChange={(e) =>
                                                this.inputSHrChange(e)
                                              }
                                            >
                                              <option defaultValue>
                                                Select Column
                                              </option>
                                              {this.state.columns.map(
                                                (api, index, idx) => (
                                                  <option
                                                    key={index}
                                                    value={api}
                                                  >
                                                    {api}
                                                  </option>
                                                )
                                              )}
                                            </Form.Control>
                                          </td>
                                          <td>
                                            {/* <Form.Select
                                              name="sampleValue"
                                              value={
                                                this.state.headerData
                                                  .sampleValue
                                              }
                                              onChange={this.inputSHrChange}
                                            >
                                              <option defaultValue>
                                                Select Value
                                              </option>
                                              {Object.keys(
                                                JSON.parse(
                                                  this.state.jsonData || "{}"
                                                )
                                              ).map((key, index) => (
                                                <option key={index} value={key}>
                                                  {key}
                                                </option>
                                              ))}
                                               {Object.keys(
                                                JSON.parse(
                                                  this.state.jsonData || "{}"
                                                )
                                              ).map((value, index) => (
                                                <option
                                                  key={index}
                                                  value={value}
                                                >
                                                  {value}
                                                </option>
                                              ))}
                                            </Form.Select> */}
                                            <Form.Select
                                              name="sampleValue"
                                              value={
                                                this.state.headerData
                                                  .sampleValue
                                              }
                                              onChange={this.inputSHrChange}
                                            >
                                              <option>Select Value</option>
                                              {Object.values(
                                                JSON.parse(
                                                  this.fixLooseJson(
                                                    this.state.jsonData || "{}"
                                                  )
                                                )
                                              ).map((value, idx) => {
                                                const displayValue =
                                                  typeof value === "object" && value !== null
                                                    ? JSON.stringify(value)
                                                    : String(value ?? "");
                                                return (
                                                  <option key={idx} value={displayValue}>
                                                    {displayValue}
                                                  </option>
                                                );
                                              })}
                                            </Form.Select>
                                          </td>
                                          <td>
                                            <Button
                                              type="button"
                                              variant="success"
                                              className="bi bi-plus"
                                              onClick={(e) =>
                                                this.addSendhrRow(table.id, e)
                                              }
                                            ></Button>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col className="d-flex justify-content-end">
                                    <Button
                                      className="button"
                                      variant="success"
                                      onClick={this.ResponsejsonsubmitHandler}
                                      style={{
                                        marginTop: "20px",
                                      }}
                                    >
                                      Save Table
                                    </Button>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                          </Row>
                        </Row>
                      </Container>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
